module.exports = __webpack_public_path__ + "img/cgzb.d20aa46.png";